module.exports = __webpack_public_path__ + "img/heart-bg-transparent.9c91c67d.svg";